import competency from "../../assets/introduction/competency.avif";
import location from "../../assets/introduction/location.avif";
import cost from "../../assets/introduction/cost.avif";

export const introductionGallery = [
    {
        title: 'კომპეტენცია',
        description: 'აირჩიეთ გამოცდილების მიხედვით',
        image: competency
    },
    {
        title: 'ლოკაცია',
        description: 'იპოვეთ მასწავლებელი თქვენთან ახლოს',
        image: location
    },
    {
        title: 'ანაზღაურება',
        description: 'აირჩიეთ ფასის მიხედვით',
        image: cost
    },
]